import React, { useState } from 'react';
import { Button, Dropdown, Tooltip, Icon } from 'antd';
import ParamsMenu from '../ParamsMenu/ParamsMenu';

const ActionsDropdown = ({ actionStyle = {} }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);

    if (visible) {
      setTooltipVisible(false);
    }
  };

  const handleTooltipVisibleChange = (visible) => {
    if (!dropdownVisible) {
      setTooltipVisible(visible);
    }
  };

  return (
    <Dropdown
      trigger={['click']}
      overlay={<ParamsMenu onClick={() => setDropdownVisible(false)} />}
      visible={dropdownVisible}
      onVisibleChange={handleDropdownVisibleChange}
    >
      <Tooltip
        title="Массовые действия"
        placement="bottom"
        visible={tooltipVisible}
        onVisibleChange={handleTooltipVisibleChange}
      >
        <Button
          type="primary"
          shape="circle"
          style={{ fontSize: '16px', ...actionStyle }}
        >
          <Icon type="unordered-list" />
        </Button>
      </Tooltip>
    </Dropdown>
  );
};

export default ActionsDropdown;
